import {GET_RECOMMENDATION_REQUEST, GET_RECOMMENDATION_REQUEST_FAILED, GET_RECOMMENDATION_REQUEST_SUCCEEDED} from "../constants/recommendation";

export const recommendation = (
  state = {
    isFetching: false,
    data: {items: []},
    error: {},
  }, action) => {
  let newState = {...state};

  switch (action.type) {
    case GET_RECOMMENDATION_REQUEST:
      newState.isFetching = true;
      return newState;

    case GET_RECOMMENDATION_REQUEST_SUCCEEDED:
      newState.isFetching = false;
      newState.data = action.data;
      newState.error = {};
      return newState;

    case GET_RECOMMENDATION_REQUEST_FAILED:
      newState.isFetching = false;
      newState.error = action.error;
      newState.data = {};
      return newState;

    default:
      return newState;
  }
};
